import Page from "../../components/Page";

export default function Donate() {
  return (
    <Page title="Donations to Earthsave">
      <p>
        <b>Imagine a world... </b>where the land is fertile, the water is clean,
        the air is fresh, and all are fed. EarthSave helps make this world a
        reality by promoting the benefits of plant-based food choices for our
        health, for our planet, and for all those who share it.
      </p>
      <br />
      <p>
        <b>Support our work</b>and together we will create a healthier, more
        peaceful, and life-sustaining world. You may donate online at{" "}
        <b>
          <a href="http://www.earthsave.org/join.htm">Earthsave Baltimore</a>
        </b>
        , or send a <b>check or money order</b> to <b>Earthsave</b> at 517
        Talbott Ave. Lutherville, MD, 21093. Thanks for your kind support.
      </p>
    </Page>
  );
}
